import { createSelector } from 'reselect';

const EMPTY_LIST = Object.freeze([]);

export const getClient = (state) => state?.clients?.listeClient || EMPTY_LIST;

export const clientOnlyChild = createSelector([getClient], (clients) => {
    return clients.filter((parent) => {
        const enfants = clients.filter((client) => client.Id_parent === parent.id);
        return enfants.length === 0;
    });
});